export default __webpack_public_path__ + "static/media/capsule-landing-token-bitcoin.c8cc409b.png";